import * as types from "../actions/actionTypes";
import initialState from "./initialState";

// The tenant the signed in account turned out to have no access to (see
// utils/tenantAccessGuard.js). The legacy iframe is not loaded for it.
export default function tenantAccessReducer(state = initialState.tenantAccess, action) {
    if (action.type === types.TENANT_ACCESS_DENIED) {
        return { ...state, deniedTenantId: action.tenantId };
    }
    else if (action.type === types.TENANT_ACCESS_CONFIRMED) {
        return state.deniedTenantId === action.tenantId ? { ...state, deniedTenantId: null } : state;
    }
    else {
        return state;
    }
}
